<template>
  <a-select
    v-if="type === 'levels'"
    :value="value || []"
    @change="onChange"
    mode="multiple"
    :placeholder="$t('enseignant.listeNiveaux')"
    style="width: 100%"
  >
    <a-select-option
      v-for="level in levelOptions"
      :key="level.value"
      :value="level.value"
    >
      {{ level.label }}
    </a-select-option>
  </a-select>
  <a-select
    v-else-if="type === 'classrooms'"
    :value="value || []"
    @change="onChange"
    mode="multiple"
    :placeholder="$t('actualite.classrooms')"
    style="width: 100%"
  >
    <a-select-option
      v-for="classe in classes"
      :key="classe._id"
      :value="classe._id"
    >
      {{ classe.name }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: "LevelsClassroomsFilter",
  props: {
    type: {
      type: String,
      required: true,
      validator: (v) => ["levels", "classrooms"].includes(v),
    },
    value: {
      type: Array,
      default: undefined,
    },
    levelOptions: {
      type: Array,
      default: () => [],
    },
    classes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onChange(e) {
      this.$emit("input", e);
      this.$emit("change", e);
    },
  },
};
</script>
